var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgC(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 36,
    viewBox: "0 0 29 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1328 23.6328C27.8672 27.3047 26.5078 30.1953 24.0547 32.3047C21.6172 34.4141 18.3984 35.4688 14.3984 35.4688C10.0234 35.4688 6.57812 34 4.0625 31.0625C1.5625 28.1094 0.3125 24.0625 0.3125 18.9219V16.8359C0.3125 13.5547 0.890625 10.6641 2.04688 8.16406C3.20312 5.66406 4.85156 3.75 6.99219 2.42188C9.14844 1.07813 11.6484 0.40625 14.4922 0.40625C18.4297 0.40625 21.6016 1.46094 24.0078 3.57031C26.4141 5.67969 27.8047 8.64062 28.1797 12.4531H21.1484C20.9766 10.25 20.3594 8.65625 19.2969 7.67188C18.25 6.67187 16.6484 6.17188 14.4922 6.17188C12.1484 6.17188 10.3906 7.01562 9.21875 8.70312C8.0625 10.375 7.46875 12.9766 7.4375 16.5078V19.0859C7.4375 22.7734 7.99219 25.4688 9.10156 27.1719C10.2266 28.875 11.9922 29.7266 14.3984 29.7266C16.5703 29.7266 18.1875 29.2344 19.25 28.25C20.3281 27.25 20.9453 25.7109 21.1016 23.6328H28.1328Z",
    fill: "url(#paint0_diamond)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.2424 16.8929) rotate(88.0754) scale(45.1147 45.0815)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD458",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9BF2E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/C.f4b237d440f1ac0f8068f22640fd1c3b.svg";
export { ForwardRef as ReactComponent };